
const link = document.createElement('link');
link.setAttribute('rel', 'stylesheet');
link.setAttribute('type', 'text/css');
link.setAttribute(
	'href', 
	Liferay.ThemeDisplay.getPathContext() + '/o/data-engine-js-components-web/js/custom/form/components/PartialResults.css'
);
document.querySelector('head').appendChild(link);
